import styled from '@emotion/styled';
import { Fonts, Spacings } from '@styles/index';
import Image from '@base/Image';
import ContinueOnAppButton from './ContinueOnAppButton';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
const CardContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
`;

const Information = styled.div``;

const Title = styled.div`
  font-weight: ${Fonts.SEMIBOLD};
  font-size: ${Fonts.SMALL};
  color: var(--color-text-primary);
`;

const SubTitle = styled.div`
  font-weight: ${Fonts.LIGHT};
  font-size: ${Fonts.ULTRA_SMALL};
  color: var(--color-text-secondary);
  margin-top: ${Spacings.SPACING_1B};
`;

const ButtonWrapper = styled.div`
  margin-top: ${Spacings.SPACING_2B};
`;

const BatchStateCard = ({
  title,
  subTitle,
  imageUrl,
  showContinueOnAppButton = true
}) => {
  return (
    <Wrapper>
      <CardContainer>
        <Information>
          {title && <Title>{title}</Title>}
          {subTitle && <SubTitle>{subTitle}</SubTitle>}
        </Information>
        {imageUrl && <Image src={imageUrl} alt="icon" width={40} height={40} />}
      </CardContainer>
      {showContinueOnAppButton && (
        <ButtonWrapper>
          <ContinueOnAppButton />
        </ButtonWrapper>
      )}
    </Wrapper>
  );
};

export default BatchStateCard;
